<main class="nf-page" aria-labelledby="nf-title">
  <section class="nf-card">
    <div class="nf-art" aria-hidden="true">
      <svg viewBox="0 0 220 120" width="220" height="120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <text x="110" y="92" text-anchor="middle" class="nf-art-code">404</text>
        <g class="nf-art-glass" transform="translate(142 22)">
          <circle cx="22" cy="22" r="17" stroke-width="5" />
          <path d="M34 34l14 14" stroke-width="6" stroke-linecap="round" />
        </g>
      </svg>
    </div>

    <h1 id="nf-title" class="nf-title">Page not found</h1>
    <p class="nf-text">
      The page you're looking for doesn't exist, has been moved, or you don't have access to it.
    </p>

    @if (shownPath()) {
    <p class="nf-path">
      <span class="nf-path-label">Requested address</span>
      <code class="nf-path-value" [pmTooltip]="shownPath()">{{ shownPath() }}</code>
    </p>
    }

    <div class="nf-actions">
      <button type="button" class="nf-btn nf-btn--ghost" (click)="goBack()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
        Go back
      </button>
      <a class="nf-btn nf-btn--primary" routerLink="/dashboard">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></svg>
        Go to Dashboard
      </a>
    </div>
  </section>
</main>
